'use client';

import { useTranslations } from 'next-intl';
import { BaseLineLoading2 } from '@/app/components/icons/BaseLineLoading2';
import { BaseLinePlus } from '@/app/components/icons/BaseLinePlus';
import { cn } from '@/app/utils';

interface CreateCardProps {
  loading?: boolean;
  onClick: () => void;
}

export const CreateCard = ({ loading, onClick }: CreateCardProps) => {
  const t = useTranslations('videoEditor.list');
  return (
    <button
      type="button"
      disabled={loading}
      onClick={onClick}
      className={cn(
        'flex h-[136px] w-[240px] flex-col items-center justify-center gap-1 rounded-2xl border border-system-white08 bg-system-white04 backdrop-blur-sm transition-colors',
        'hover:border-system-white16 hover:bg-system-white08',
        'disabled:cursor-not-allowed disabled:opacity-60',
      )}
    >
      {loading ? (
        <BaseLineLoading2 className="size-6 animate-spin text-system-white64" />
      ) : (
        <BaseLinePlus className="size-6 text-system-white" />
      )}
      <span className="text-center text-sm text-system-white64 tracking-[0.28px]">{t('createCard')}</span>
    </button>
  );
};
